import * as React from 'react';
import { Theme } from '@mui/material';
import Grid from '@mui/material/Grid';
import { TextV2 } from '@insights-ltd/design-library/components';
import { JobButton } from 'components/Jobs/Buttons/JobButton';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';

type RemovingStringsControlProps = {
  allStringsSelected: boolean;
  setSelectedStrings: (key: string[]) => void;
  stopRemovingStrings: () => void;
  onSelectAllStrings: () => void;
};

const RemovingStringsControl = ({
  allStringsSelected,
  setSelectedStrings,
  stopRemovingStrings,
  onSelectAllStrings,
}: RemovingStringsControlProps) => {
  return (
    <Grid
      container
      spacing={1}
      sx={(theme: Theme) => ({
        alignItems: 'center',
        paddingRight: theme.spacing(spacingSizeMap.XS),
      })}
    >
      <Grid>
        <TextV2 variant="h3">Remove strings from job</TextV2>
      </Grid>
      <Grid
        sx={{
          marginLeft: 'auto',
        }}
      >
        <JobButton
          variant="outlined"
          color="primary"
          onClick={
            allStringsSelected
              ? () => setSelectedStrings([])
              : onSelectAllStrings
          }
        >
          {allStringsSelected ? 'Deselect all strings' : 'Select all strings'}
        </JobButton>
      </Grid>
      <Grid>
        <JobButton
          variant="outlined"
          color="primary"
          onClick={stopRemovingStrings}
        >
          Cancel
        </JobButton>
      </Grid>
    </Grid>
  );
};

export default RemovingStringsControl;
